/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { Global, jsx } from '@emotion/react';
import { useSharedPluginState } from '@atlaskit/editor-common/hooks';
import { useSharedPluginStateSelector } from '@atlaskit/editor-common/use-shared-plugin-state-selector';
import { editorExperiment } from '@atlaskit/tmp-editor-statsig/experiments';
import { tableStyles } from './common-styles';
export var GlobalStylesWrapper = function GlobalStylesWrapper(_ref) {
  var featureFlags = _ref.featureFlags,
    isDragAndDropEnabledOption = _ref.isDragAndDropEnabledOption,
    api = _ref.api;
  // mode
  var _useSharedPluginState = useSharedPluginState(api, ['editorViewMode'], {
      disabled: editorExperiment('platform_editor_usesharedpluginstateselector', true)
    }),
    editorViewModeState = _useSharedPluginState.editorViewModeState;
  var modeSelector = useSharedPluginStateSelector(api, 'editorViewMode.mode', {
    disabled: editorExperiment('platform_editor_usesharedpluginstateselector', false)
  });
  var mode = editorExperiment('platform_editor_usesharedpluginstateselector', true) ? modeSelector : editorViewModeState === null || editorViewModeState === void 0 ? void 0 : editorViewModeState.mode;
  var isLivePageViewMode = mode === 'view';
  return jsx(Global, {
    styles: tableStyles({
      featureFlags: featureFlags,
      isDragAndDropEnabled: isDragAndDropEnabledOption && !isLivePageViewMode
    })
  });
};